import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=a8f3b04e&scoped=true"
import script from "./UnderMaintenance.vue?vue&type=script&lang=ts"
export * from "./UnderMaintenance.vue?vue&type=script&lang=ts"
import style0 from "./UnderMaintenance.vue?vue&type=style&index=0&id=a8f3b04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f3b04e",
  null
  
)

export default component.exports